// @flow
export const FORM_ERROR_CLASSNAME = 'error-field'; // for scroll on error
export const ALERT_CLASSNAME = 'alert'; // for scroll on error



// WEBPACK FOOTER //
// ../react-lib/src/constants/classNames.constants.js